import { render, staticRenderFns } from "./mangeList.vue?vue&type=template&id=84f35dca&scoped=true&"
import script from "./mangeList.vue?vue&type=script&lang=js&"
export * from "./mangeList.vue?vue&type=script&lang=js&"
import style0 from "./mangeList.vue?vue&type=style&index=0&id=84f35dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f35dca",
  null
  
)

export default component.exports